var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Turno",
      "outlined": "",
      "maxlength": "25",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurnos.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "descricao", $$v);
      },
      expression: "form.filters.descricao"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    on: {
      "enter": _vm.buscarTurnos
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##:##',
      expression: "'##:##'"
    }],
    attrs: {
      "label": "Hora de Início",
      "outlined": "",
      "dense": "",
      "rules": [function (h) {
        return _vm.horaValida(h);
      }]
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurnos.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.horaInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "horaInicio", $$v);
      },
      expression: "form.filters.horaInicio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##:##',
      expression: "'##:##'"
    }],
    attrs: {
      "label": "Hora de Término",
      "outlined": "",
      "dense": "",
      "rules": [function (h) {
        return _vm.horaValida(h);
      }]
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarTurnos.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.horaFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "horaFim", $$v);
      },
      expression: "form.filters.horaFim"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarTurnos();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterTurno();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": _vm.table.noDataText
    },
    scopedSlots: _vm._u([{
      key: `item.situacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarTurno(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterTurno(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarTurno(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarTurnoDialog', {
    attrs: {
      "visible": _vm.dialogManterTurno.visible,
      "content": _vm.dialogManterTurno.content,
      "edit": _vm.dialogManterTurno.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterTurno.close();
      },
      "onSave": function ($event) {
        return _vm.buscarTurnos();
      }
    }
  }), _vm.dialogVisualizarTurno.visible ? _c('VisualizarTurnoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarTurno.visible,
      "content": _vm.dialogVisualizarTurno.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarTurno.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }